/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'mark': {
    width: 14,
    height: 11,
    viewBox: '0 0 14 11',
    data: '<path pid="0" d="M1.25 5.75l4.5 3.5 7-8.5" _stroke="#fff" stroke-width="2"/>'
  }
})
